

export class DocumentTypeStatusInput implements IDocumentTypeStatusInput {
    /** The auto-generated id of the document type master */
    documentTypeId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IDocumentTypeStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DocumentTypeStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDocumentTypeStatusInput {
    /** The auto-generated id of the document type master */
    documentTypeId: number;
    /** The updated status */
    status: number;
}

